export default "__VITE_ASSET__7OUblYkG__"